<template>
  <div>
    <v-layout>
      <v-flex
        :class="`${headline} ${isMobile ? 'mb-3' : 'mb-5'}`">{{ text }}
        <div
          v-if="appointmentId"
          class="grey--text ids"
          style="">案件番号{{ appointmentId }} 車両番号{{ carId }}</div>
        <v-alert
          :value="!isOnline"
          outline
          color="danger"
          class="caption red--text">
          インターネット接続がないので「写真」「破損」「修復歴」の変更はできません。</v-alert>
      </v-flex>
    </v-layout>
    <v-divider
      v-if="!isMobile"
      class="mb-5" />
  </div>
</template>

<style scoped>
.ids {
  font-size: 8px;
}
</style>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    carId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    appointmentId() {
      return this.$route.params.id || 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/elements/TabTitle.vue